/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_ToInputs */

const cs_dashboard_period_to = /** @type {(inputs: Dashboard_Period_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const en_dashboard_period_to = /** @type {(inputs: Dashboard_Period_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Dashboard_Period_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_to = /** @type {((inputs?: Dashboard_Period_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_to(inputs)
	return cs_dashboard_period_to(inputs)
});